import { mapGetters } from 'vuex';

export const interactionSound = {
  computed: {
    ...mapGetters({
      soundsEnabled: 'location/soundsEnabled',
    }),
  },
  methods: {
    playInteractionSound() {
      if (this.soundsEnabled) {
        const audio = new Audio('/audio/tap.wav');
        audio.play().catch(error => {
          console.error("Error playing interaction sound:", error);
        });
      }
    },
  },
};
